import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';
import config from "../coreFIles/config";
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'

import { SendForgotPasswordMailAction } from '../Action/action';

const getDomainId = () => {
	try {
		const cookieData = Cookies.get('domain_id');
		return cookieData ? JSON.parse(cookieData) : 0;
	} catch (error) {
		console.error('Error parsing domain_id cookie:', error);
		return 0;
	}
};

const Domainid = getDomainId();

const ForgotPassword = () => {
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');

	// style end
	const [form, setForm] = useState({ master_id: "3", domain_id: Domainid ? Domainid.domain_id : "0", email:''});

	const [validatioError, setvalidatioError] = useState({});

	const inputHandler = async (e) => {
		const { name, value } = e.target
		setForm((old) => {
			return { ...old, [name]: value }
		})
	}

	function validate() {
		let emailError = "";
		if (form.email === '') 
			emailError = "Email is required."
		

		if (emailError) {
			setvalidatioError({
				emailError
			})

			return false
		} else {
			setvalidatioError({
				emailError
			})
			return true
		}
	}

	const send_FPM = async (e) => {
		e.preventDefault() 
		let valid = validate()
		if(!valid) return
		console.log("hello")
		let res = await SendForgotPasswordMailAction(form);
		
		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.href = `${config.baseUrl}login`;
			},4000);
		} else {
			toast.error(res.msg);
		}
	}


	return (
		<>
			<Header />

			<div className="add-section mb-3">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Leftnav />
						</div>
						<div className="col-lg-6">
							<Toaster />

							<div className="classification-section">
								<h2 className="page-heading" style={{ background: headerMenuColor }}>Member Forgot Password</h2>
								<form action='#'>
									<div className="bondiclassified-fromsection">
										<div className="catagoryfrom">
											<div className="member-login">
												<div className="row">
													<div className="col-md-12 col-sm-12 user">
														<img src={config.baseUrl + "img/user.png"} alt='img' />
													</div>
													<div className="col-md-12 col-sm-12">
														<div className="form-group">
															{/* <label for="memberemail">Email</label> */}
															<input type="text" className="form-control" name="email" id="email" placeholder="Enter Your Email" onChange={inputHandler} />
															<span className="text-danger">{validatioError.emailError}</span>
														</div>
													</div>
												</div>
												<div className="row">
													<div className="col-md-12 mt-3">
														<button type="submit" onClick={send_FPM} className="btn btn-primary login-btn" style={{ background: headerButtonColor }} >Submit</button>

													</div>
													<div className="col-md-12">
														<Link to={config.baseUrl + 'login'} className="btn btn-primary login-btn fb">Login</Link>

														<Link to={config.baseUrl + 'register'} className="btn btn-primary login-btn reg">Register Now</Link>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>

							</div>
						</div>
						<div className="col-lg-3">
							<Rightnav />
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	)

}

export default ForgotPassword;
